import { render } from "./RankingPreview.vue?vue&type=template&id=5664d41c"
import script from "./RankingPreview.vue?vue&type=script&lang=js"
export * from "./RankingPreview.vue?vue&type=script&lang=js"

import "./RankingPreview.vue?vue&type=style&index=0&id=5664d41c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__